<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoCheckbox from "@/components/formControls/SoCheckbox.vue"
  import { SoDataTableHeader } from "@/types/components/SoDataTable"
  import { IComplaint } from "@/models/complaint/complaint.types"
  import { Complaint as ComplaintRaw } from "@/api/hasura/generated/graphql"
  import OpsComplaintGroupColumnSelector from "@/views/operations/complaints/components/OpsComplaintGroupColumnSelector.vue"

  export type ComplaintsSelectorConfig = {
    title: string
    headers: SoDataTableHeader<keyof IComplaint, keyof ComplaintRaw>[]
  }

  export default defineComponent({
    name: "OpsComplaintColumnSelector",
    components: { OpsComplaintGroupColumnSelector, SoCheckbox },
    props: {
      modelValue: {
        type: Array as PropType<(keyof IComplaint)[]>,
        default: () => [],
      },
      config: {
        type: Array as PropType<ComplaintsSelectorConfig[]>,
        default: () => [],
      },
    },
    emits: ["update:modelValue"],
    computed: {
      selectedHeaders: {
        get() {
          return this.modelValue
        },
        set(val: Array<string>) {
          this.$emit("update:modelValue", val)
        },
      },
    },
  })
</script>

<template>
  <div v-for="(columnConfig, index) in config" :key="index" class="mb-5">
    <OpsComplaintGroupColumnSelector
      v-model="selectedHeaders"
      :column-config="columnConfig"
    />
    <div class="d-flex align-center gap-1 flex-wrap">
      <SoCheckbox
        v-for="header in columnConfig.headers"
        :key="header.key"
        v-model="selectedHeaders"
        :label="header.title"
        type="compact"
        :value="header.key"
        data-testid="column-selector-checkbox"
        multiple
      />
    </div>
  </div>
</template>
